import React from 'react'
import CommingSoon from '../../components/global/comming/CommingSoon'

const TicketsPage = () => {
    return (
        <div>
            {/* TicketsPage */}
            <CommingSoon></CommingSoon>
        </div>
    )
}

export default TicketsPage
